import { useState } from 'react';
import { Backdrop, Box, CircularProgress, Divider, Grid, Paper, Stack, Typography } from '@mui/material';
import { LocationForm } from '../location';
import { ImageViewer } from '../image-viewer';
import { ShowInfo } from '../show-info';
import { initiateInspection } from '../../config/axios';
import { printProbability } from '../../utils';
import { BP_COLOR } from '../../bp-theme';
import { useNotify } from '../../hooks';
import { useAuthentication } from '../../hooks/use-authentication';

export const Home = () => {
  useAuthentication();
  const [result, setResult] = useState();
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [item, setItem] = useState('pool');
  const notify = useNotify();

  const detectItem = async (type, file) => {
    try {
      setOpenBackdrop(true);
      setItem(type);
      const { data } = await initiateInspection(type, file);
      setResult(data);
    } catch (error) {
      notify(error.message, { type: 'error' });
    } finally {
      setOpenBackdrop(false);
    }
  };

  return (
    <div className='box-style'>
      <Grid container sx={{ py: 1 }}>
        <Grid item xs={4}>
          <Box sx={{ py: 2 }}>
            <LocationForm detectItem={detectItem} openBackdrop={setOpenBackdrop} setItem={setItem} item={item} />
          </Box>
          {result && (
            <Box sx={{ py: 3 }}>
              <Paper elevation={2} sx={{ maxWidth: 340, py: 1, px: 3, m: 'auto' }}>
                <Typography variant='h5' color={BP_COLOR[10]} my={1}>
                  Résultat
                </Typography>
                <Divider />
                <Stack spacing={2} my={3}>
                  <ShowInfo label={`Nombre de ${item === 'pool' ? 'piscine' : 'velux'} détectées`} value={result.nbPools || result.nbVelux} />
                  <Typography variant='h6' color={BP_COLOR[10]}>
                    Probabilités
                  </Typography>
                  {result.probas.map((proba, id) => (
                    <ShowInfo label={`${item === 'pool' ? 'Piscine' : 'Velux'} ${id + 1}`} value={printProbability(proba)} />
                  ))}
                </Stack>
              </Paper>
            </Box>
          )}
        </Grid>
        <Grid item xs={8}>
          {result ? (
            <Box>
              <ImageViewer source={result.image_uri} />
            </Box>
          ) : (
            <Stack spacing={2} sx={{ width: '70%', m: 3 }}>
              <Typography variant='h4' color={BP_COLOR[10]}>
                BPartners Item
              </Typography>
              <Typography variant='h6'>
                BPartners Item détecte pour vous les items intéressants, que ce soit des piscines ou des velux dans une zone choisie.
              </Typography>
              <Typography variant='h5'>Comment procéder ?</Typography>
              <Typography variant='h6'>Fournissez les coordonnées GPS de la zone que vous souhaitez inspecter... Et voilà !</Typography>
            </Stack>
          )}
        </Grid>
      </Grid>
      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={openBackdrop}>
        <Stack spacing={2}>
          <Box m='auto'>
            <CircularProgress color='inherit' />
          </Box>
          <Typography variant='body1'>Détection en cours...</Typography>
        </Stack>
      </Backdrop>
    </div>
  );
};
